import { render } from "./box.vue?vue&type=template&id=7d16a4d2"
import script from "./box.vue?vue&type=script&lang=js"
export * from "./box.vue?vue&type=script&lang=js"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__